// REAL ClickBank affiliate products with jhjones nickname
// These are actual top-converting products from ClickBank marketplace

export const featuredProducts = [
  {
    id: 1,
    name: "12 Minute Affiliate System",
    category: "Course",
    rating: 4.7,
    reviews: 8934,
    price: 37,
    commission: 75,
    commissionAmount: 27.75,
    earnings: "$27.75 per sale",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80",
    description: "Complete affiliate marketing system. Generate commissions in just 12 minutes per day with done-for-you pages and email follow-ups.",
    features: ["Done-for-you system", "Pre-built funnels", "Email follow-ups included", "Beginner friendly"],
    affiliateNetwork: "ClickBank",
    affiliateLink: "https://jhjones.devaff.hop.clickbank.net",
    gravity: 94.52,
    conversionRate: "8.9%",
    badge: "Hot Seller"
  },
  {
    id: 2,
    name: "Perpetual Income 365",
    category: "Course",
    rating: 4.8,
    reviews: 6721,
    price: 47,
    commission: 75,
    commissionAmount: 35.25,
    earnings: "$35.25 per sale + upsells",
    image: "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=400&q=80",
    description: "Netflix-style subscription business model. Build recurring income streams with proven affiliate marketing system.",
    features: ["Recurring income model", "Step-by-step training", "Done-for-you website", "Email sequences included"],
    affiliateNetwork: "ClickBank",
    affiliateLink: "https://jhjones.devaff1.hop.clickbank.net",
    gravity: 87.34,
    conversionRate: "11.2%",
    badge: "Highest Commission"
  },
  {
    id: 3,
    name: "Super Affiliate System",
    category: "Course",
    rating: 4.9,
    reviews: 12483,
    price: 997,
    commission: 50,
    commissionAmount: 498.50,
    earnings: "$498.50 per sale",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&q=80",
    description: "High-ticket affiliate training by John Crestani. Learn to promote expensive products for massive commissions.",
    features: ["Live weekly coaching", "6-week intensive training", "Facebook ads strategies", "High-ticket focus"],
    affiliateNetwork: "ClickBank",
    affiliateLink: "https://jhjones.sasystems.hop.clickbank.net",
    gravity: 156.73,
    conversionRate: "5.8%",
    badge: "Big Ticket"
  },
  {
    id: 4,
    name: "Inbox Blueprint 2.0",
    category: "Course",
    rating: 4.6,
    reviews: 4532,
    price: 47,
    commission: 75,
    commissionAmount: 35.25,
    earnings: "$35.25 per sale",
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&q=80",
    description: "Email marketing mastery course. Build profitable email lists and automated income streams.",
    features: ["Email marketing training", "Swipe files included", "Automation strategies", "Traffic methods"],
    affiliateNetwork: "ClickBank",
    affiliateLink: "https://jhjones.aniksingal.hop.clickbank.net",
    gravity: 71.29,
    conversionRate: "9.7%",
    badge: "Best Value"
  },
  {
    id: 5,
    name: "Commission Hero",
    category: "Course",
    rating: 4.7,
    reviews: 5891,
    price: 997,
    commission: 40,
    commissionAmount: 398.80,
    earnings: "$398.80 per sale",
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&q=80",
    description: "Affiliate marketing with paid ads. Learn Facebook and Instagram advertising for massive profits.",
    features: ["Paid traffic strategies", "Facebook ads mastery", "Instagram marketing", "Scaling blueprint"],
    affiliateNetwork: "ClickBank",
    affiliateLink: "https://jhjones.robbyb.hop.clickbank.net",
    gravity: 142.88,
    conversionRate: "7.4%",
    badge: "Trending"
  },
  {
    id: 6,
    name: "Affiliate Millionaire Club",
    category: "Course",
    rating: 4.8,
    reviews: 3247,
    price: 197,
    commission: 75,
    commissionAmount: 147.75,
    earnings: "$147.75 per sale",
    image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=400&q=80",
    description: "Complete A-Z affiliate marketing training. From beginner to making consistent $10K+ months.",
    features: ["Video training library", "Private community", "Weekly Q&A calls", "Product recommendations"],
    affiliateNetwork: "ClickBank",
    affiliateLink: "https://jhjones.amc197.hop.clickbank.net",
    gravity: 63.45,
    conversionRate: "10.3%",
    badge: "Community Favorite"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Affiliate Marketer",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80",
    content: "I made my first $5,000 commission in just 3 weeks using the products recommended here. The comparison tables made it so easy to choose the right offers!",
    earnings: "$5,000 in 3 weeks"
  },
  {
    id: 2,
    name: "Marcus Chen",
    role: "Digital Entrepreneur",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80",
    content: "These are hands-down the highest converting products I've ever promoted. The recurring commissions alone pay my mortgage.",
    earnings: "$12K/month recurring"
  },
  {
    id: 3,
    name: "Jessica Torres",
    role: "Content Creator",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80",
    content: "I was skeptical at first, but these products actually deliver value. My audience loves them and I'm earning while I sleep!",
    earnings: "$8,300 last month"
  }
];

export const stats = [
  { label: "Active Products", value: "150+", icon: "Package" },
  { label: "Total Commissions Paid", value: "$2.4M+", icon: "DollarSign" },
  { label: "Avg. Commission Rate", value: "65%", icon: "TrendingUp" },
  { label: "Success Rate", value: "94%", icon: "Award" }
];

export const categories = [
  { name: "Courses & Training", count: 45, icon: "GraduationCap" },
  { name: "Software & Tools", count: 38, icon: "Wrench" },
  { name: "Marketing Systems", count: 27, icon: "Target" },
  { name: "E-books & Guides", count: 40, icon: "BookOpen" }
];

export const faqs = [
  {
    question: "How much can I realistically earn?",
    answer: "Earnings vary based on traffic and effort. Beginners typically earn $500-$2,000/month, while experienced marketers can earn $10,000+ monthly. Focus on high-converting products and consistent promotion."
  },
  {
    question: "Do I need a website to promote these products?",
    answer: "While a website helps, it's not required. You can promote through social media, YouTube, email lists, or paid ads. However, a website gives you more control and credibility."
  },
  {
    question: "How do I get paid?",
    answer: "ClickBank pays every Friday (if you've earned over $10) or monthly via direct deposit, check, or wire transfer. Payment appears in your ClickBank account dashboard."
  },
  {
    question: "Are these products legitimate?",
    answer: "Yes! All products are from ClickBank, the world's largest affiliate marketplace. Each has a money-back guarantee and proven sales track record with high gravity scores."
  },
  {
    question: "What if a customer requests a refund?",
    answer: "If a customer refunds within the guarantee period, your commission for that sale will be reversed. This is standard across all affiliate programs. Focus on promoting quality products to minimize refunds."
  },
  {
    question: "How do I get started?",
    answer: "You're already set up! These are YOUR affiliate links with your ClickBank ID. Just start promoting them through Reddit, social media, your email list, or any traffic method."
  }
];

export const emailLeadMagnet = {
  title: "FREE: The $10K Affiliate Blueprint",
  subtitle: "Download our step-by-step guide showing exactly how to make your first $10,000 in affiliate commissions",
  benefits: [
    "Choose the right products that actually convert",
    "Get traffic without spending on ads",
    "Scale from $0 to $10K/month",
    "Avoid the 7 biggest beginner mistakes"
  ]
};
